// extracted by mini-css-extract-plugin
export default {"dialog":"WhiteModal_dialog__wIwNo","paper":"WhiteModal_paper__W5OIA","header":"WhiteModal_header__334WV"};